import React from "react";
import { translate } from "../../Services/translation";

const MiniCart = ({ quantity, orderTotal, checkoutUrl, cartPageUrl, showInfo, toggle }) => (
  <div className="cart cart--mini">
    <a className="cart__link--block" onClick={() => toggle()}>
      <i className="cart__icon">
        <svg className="icon">
			        <use xlinkHref="/ui/images/JobMeal/icons/icons.svg#cart"></use>
		    </svg>
      </i>
      <span className="cart__quantity">{quantity}</span>
      <span className="cart__title">{translate("minicart.title")}</span>
    </a>
    { <div className={`cart__info ${!showInfo ? "cart__info--hidden" : ""}`}>
      <span className="modal__close-button" onClick={() => toggle()}></span>
      <p className="cart__info-row cart__info-row--quantity">
        <span>{translate("minicart.numberofproduct")}</span> {quantity}
      </p>
      <p className="cart__info-row cart__info-row--total">
        <b>{translate("minicart.total")}</b> {orderTotal}
      </p>
      <a href={cartPageUrl} className="cart__checkout-button button">
        {translate("minicart.checkout")}
      </a>
    </div>}
  </div>
);

export default MiniCart;
